import request from '../utils/request.js'
//中英文切换-index/lang
export const setLang = data => {
  return request({
    url: '/index/lang',
    method: 'post',
    data
  })
}
//导航查询-index/nav
export const getNav = params => {
  return request({
    url: '/index/nav',
    method: 'get',
    params
  })
}
//新闻列表查询-/index/news
export const getNews = params => {
  return request({
    url: '/index/news',
    method: 'get',
    params
  })
}

//核心业务查询-index/business
export const getBusiness = params => {
  return request({
    url: '/index/business',
    method: 'get',
    params
  })
}

//核心业务详情-index/kernel
export const getKernel = params => {
  return request({
    url: '/index/kernel',
    method: 'get',
    params
  })
}

//案例欣赏查询-index/caselist
export const getCaselist = params => {
  return request({
    url: '/index/caselist',
    method: 'get',
    params
  })
}

//案例欣赏详情index/casedetails
export const getCasedetails = params => {
  return request({
    url: '/index/casedetails',
    method: 'get',
    params
  })
}

//新闻详情index/newsdetails
export const getNewsdetails = params => {
  return request({
    url: '/index/newsdetails',
    method: 'get',
    params
  })
}

///bs/index/banner?type=1 banner查询
export const bannerList = params => {
  return request({
    url: '/index/banner',
    method: 'get',
    params
  })
}